import Core from '@/core/module';

export default class Mobilemenu extends Core {
    init() {
        this.addEventListeners();
    }

    addEventListeners() {
        $('[show-mobilemenu]').on('click', (e) => {
            e.preventDefault();

            this.$el.show();

            setTimeout(() => {
                this.$el.addClass('mobile-menu--show');
            }, 1);
        });

        $('[close-mobilemenu]').on('click', (e) => {
            e.preventDefault();

            this.$el.removeClass('mobile-menu--show');

            setTimeout(() => {
                this.$el.hide();
            }, 400);
        });
    }
} 